/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type C4CModeEnum = "CASE4CAUSE" | "GRAPEFULCLUB" | "NONE" | "%future added value";
export type CartPromoCodeAutoAddInput = {
    readonly calculateShippingCosts?: boolean | null;
    readonly clientMutationId?: string | null;
};
export type CartPromoCodeAutoAddMutationVariables = {
    readonly input: CartPromoCodeAutoAddInput;
};
export type CartPromoCodeAutoAddMutationResponse = {
    readonly cartPromoCodeAutoAdd: ({
        readonly cart: ({
            readonly id: string;
            readonly autoShipEnabled: boolean | null;
            readonly autoShipIntervalUnit: string | null;
            readonly autoShipIntervalCount: number | null;
            readonly enrollingAsPc: boolean | null;
            readonly c4cMode: C4CModeEnum | null;
            readonly totalMinusSavings: number | null;
            readonly total: number | null;
            readonly subTotalPriceOfItemsWithPromoCodes: number | null;
            readonly promoCodeErrorKeys: ReadonlyArray<string | null> | null;
            readonly promoCodeErrorValues: ReadonlyArray<string | null> | null;
            readonly taxRate: number | null;
            readonly totalSavings: number | null;
            readonly promoCodeSavings: number | null;
            readonly pcPotentialSavings: ReadonlyArray<number | null> | null;
            readonly viaQualifiedCartTotal: number | null;
            readonly subTotalPriceOfItems: number | null;
            readonly taxTotal: number | null;
            readonly shippingInfo: ({
                readonly shippingMethod: string | null;
            }) | null;
            readonly shippingCosts: ({
                readonly upsGround: number | null;
            }) | null;
            readonly shippingPrice: number | null;
            readonly promoCodeIsValid: boolean | null;
            readonly promoCodes: ReadonlyArray<({
                readonly code: string | null;
                readonly promoDescription: string | null;
                readonly id: string;
                readonly thresholds: ReadonlyArray<({
                    readonly spendAmount: string | null;
                    readonly spendQuantity: string | null;
                    readonly discountAmount: string | null;
                    readonly discountFree: string | null;
                    readonly discountTax: string | null;
                    readonly discountShipping: string | null;
                }) | null> | null;
            }) | null> | null;
            readonly wordPressCoupons: ReadonlyArray<({
                readonly code: string | null;
                readonly couponDescription: string | null;
            }) | null> | null;
            readonly wordPressCouponSavings: ReadonlyArray<number | null> | null;
        }) | null;
        readonly clientMutationId: string | null;
    }) | null;
};
export type CartPromoCodeAutoAddMutation = {
    readonly response: CartPromoCodeAutoAddMutationResponse;
    readonly variables: CartPromoCodeAutoAddMutationVariables;
};



/*
mutation CartPromoCodeAutoAddMutation(
  $input: CartPromoCodeAutoAddInput!
) {
  cartPromoCodeAutoAdd(input: $input) {
    cart {
      id
      autoShipEnabled
      autoShipIntervalUnit
      autoShipIntervalCount
      enrollingAsPc
      c4cMode
      totalMinusSavings
      total
      subTotalPriceOfItemsWithPromoCodes
      promoCodeErrorKeys
      promoCodeErrorValues
      taxRate
      totalSavings
      promoCodeSavings
      pcPotentialSavings
      viaQualifiedCartTotal
      subTotalPriceOfItems
      taxTotal
      shippingInfo {
        shippingMethod
      }
      shippingCosts {
        upsGround
      }
      shippingPrice
      promoCodeIsValid
      promoCodes {
        code
        promoDescription
        id
        thresholds {
          spendAmount
          spendQuantity
          discountAmount
          discountFree
          discountTax
          discountShipping
        }
      }
      wordPressCoupons {
        code
        couponDescription
        id
      }
      wordPressCouponSavings
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "CartPromoCodeAutoAddInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "CartPromoCodeAutoAddInput!"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalSavings",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "autoShipIntervalUnit",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "autoShipIntervalCount",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "enrollingAsPc",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "c4cMode",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalMinusSavings",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "subTotalPriceOfItemsWithPromoCodes",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "promoCodeErrorKeys",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "promoCodeErrorValues",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "taxRate",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "autoShipEnabled",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "promoCodeSavings",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "pcPotentialSavings",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "viaQualifiedCartTotal",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "subTotalPriceOfItems",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "taxTotal",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "shippingInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "CartShippingInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingMethod",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v21 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "shippingCosts",
        "storageKey": null,
        "args": null,
        "concreteType": "CartShippingCosts",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "upsGround",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "shippingPrice",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "promoCodeIsValid",
        "args": null,
        "storageKey": null
    } as any), v24 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
    } as any), v25 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "promoCodes",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoCode",
        "plural": true,
        "selections": [
            (v24 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "promoDescription",
                "args": null,
                "storageKey": null
            },
            (v3 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "thresholds",
                "storageKey": null,
                "args": null,
                "concreteType": "PromoCodeThresholds",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "spendAmount",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "spendQuantity",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "discountAmount",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "discountFree",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "discountTax",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "discountShipping",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any), v26 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "couponDescription",
        "args": null,
        "storageKey": null
    } as any), v27 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "wordPressCouponSavings",
        "args": null,
        "storageKey": null
    } as any), v28 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CartPromoCodeAutoAddMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "cartPromoCodeAutoAdd",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CartPromoCodeAutoAddPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "cart",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Cart",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v12 /*: any*/),
                                (v13 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                (v16 /*: any*/),
                                (v17 /*: any*/),
                                (v18 /*: any*/),
                                (v19 /*: any*/),
                                (v20 /*: any*/),
                                (v21 /*: any*/),
                                (v22 /*: any*/),
                                (v23 /*: any*/),
                                (v25 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "wordPressCoupons",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "WordPressCoupon",
                                    "plural": true,
                                    "selections": [
                                        (v24 /*: any*/),
                                        (v26 /*: any*/)
                                    ]
                                },
                                (v27 /*: any*/)
                            ]
                        },
                        (v28 /*: any*/)
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "CartPromoCodeAutoAddMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "cartPromoCodeAutoAdd",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CartPromoCodeAutoAddPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "cart",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Cart",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v12 /*: any*/),
                                (v13 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                (v16 /*: any*/),
                                (v17 /*: any*/),
                                (v18 /*: any*/),
                                (v19 /*: any*/),
                                (v20 /*: any*/),
                                (v21 /*: any*/),
                                (v22 /*: any*/),
                                (v23 /*: any*/),
                                (v25 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "wordPressCoupons",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "WordPressCoupon",
                                    "plural": true,
                                    "selections": [
                                        (v24 /*: any*/),
                                        (v26 /*: any*/),
                                        (v3 /*: any*/)
                                    ]
                                },
                                (v27 /*: any*/)
                            ]
                        },
                        (v28 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "CartPromoCodeAutoAddMutation",
            "id": null,
            "text": "mutation CartPromoCodeAutoAddMutation(\n  $input: CartPromoCodeAutoAddInput!\n) {\n  cartPromoCodeAutoAdd(input: $input) {\n    cart {\n      id\n      autoShipEnabled\n      autoShipIntervalUnit\n      autoShipIntervalCount\n      enrollingAsPc\n      c4cMode\n      totalMinusSavings\n      total\n      subTotalPriceOfItemsWithPromoCodes\n      promoCodeErrorKeys\n      promoCodeErrorValues\n      taxRate\n      totalSavings\n      promoCodeSavings\n      pcPotentialSavings\n      viaQualifiedCartTotal\n      subTotalPriceOfItems\n      taxTotal\n      shippingInfo {\n        shippingMethod\n      }\n      shippingCosts {\n        upsGround\n      }\n      shippingPrice\n      promoCodeIsValid\n      promoCodes {\n        code\n        promoDescription\n        id\n        thresholds {\n          spendAmount\n          spendQuantity\n          discountAmount\n          discountFree\n          discountTax\n          discountShipping\n        }\n      }\n      wordPressCoupons {\n        code\n        couponDescription\n        id\n      }\n      wordPressCouponSavings\n    }\n    clientMutationId\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '572bda04dc8e3ee5c2da46e7e9dc17a5';
export default node;
